module.exports = __webpack_public_path__ + "img/Swesharp.047cad05.png";